import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");

// If the root already has pre-rendered content (from our postbuild snapshot),
// hydrate instead of replacing it — preserves SEO HTML for the first paint.
const hasPrerenderedContent = rootEl.hasChildNodes() &&
  // Ignore the off-screen SEO fallback (it's the only child and is absolutely positioned)
  !(rootEl.children.length === 1 && rootEl.firstElementChild?.getAttribute('aria-hidden') === 'false');

if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
